//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import mainSlider from "~/components/main-slider";
import MainSliderV2 from "~/components/main-slider-v2";
import VideoGallary1 from "~/components/video-gallary-1";
import { KinesisContainer, KinesisElement } from "vue-kinesis";
import SocialShareBtns from "~/components/social-share-btns";
import ProductPresentationHead from "~/components/loading-placeholders/product-presentation-head-pl";
export default {
  layout: "nav-fixed",
  data() {
    return {};
  },
  async asyncData({ store }) {
    await store.dispatch("our-purpose/getMJFFoundationPage");
    const pageData = store.state["our-purpose"].mjfFoundation;
    return { pageData };
  },
  head() {
    return {
      title: this.pageData.seo.meta_title,
      meta: [
        {
          name: "description",
          hid: "description",
          content: this.pageData.seo.meta_description,
        },
        {
          name: "og:description",
          hid: "og:description",
          content: this.pageData.seo.meta_description,
        },
        {
          name: "keywords",
          hid: "keywords",
          content: this.pageData.seo.keywords,
        },
        {
          property: "og:url",
          content: `https://www.dilmahtea.com${this.$route.path}`,
        },

        {
          property: "og:image",
          hid: "og:image",
          content: this.pageData.seo.share_image_url,
        },
        {
          property: "og:title",
          hid: "og:title",
          content: this.pageData.seo.meta_title,
        },
        {
          property: "og:image:alt",
          hid: "og:image:alt",
          content: this.pageData.seo.share_image_alt,
        },

        {
          name: "shareImageAlt",
          hid: "shareImage",
          content: this.pageData.seo.share_image_alt,
        },
        {
          name: "shareImage",
          hid: "shareImage",
          content: this.pageData.seo.share_image_url,
        },
        {
          name: "preventindex",
          hid: "preventindex",
          content: this.pageData.seo.prevent_indexing,
        },
      ],
    };
  },

  mounted() {
    this.$store.dispatch("getFeaturedStories", {
      type: "mjf_foundation",
      page: 1,
      size: 10,
    });
  },
  components: {
    mainSlider,
    MainSliderV2,
    VideoGallary1,
    KinesisContainer,
    KinesisElement,
    SocialShareBtns,
    ProductPresentationHead,
  },
  computed: {
    sliderMedia() {
      if (this.$store.state["our-purpose"].mjfFoundation != null) {
        return this.$store.state["our-purpose"].mjfFoundation.sliders.map(
          (item) => ({
            type: item.slider_has_video ? "VID" : "IMG",
            url: item.slider_has_video ? item.video_url : item.image_url,
          })
        );
      }
    },
    featuredData() {
      return this.$store.state.featuredStories.mjf_foundation.map((item) => ({
        image: item.thumbnail,
        text: item.name,
        hash: item.name.split(" ").join("_"),
        shortDescription: item.short_description,
        category:
          item.category == "press_articles"
            ? "media/dilmah-in-press"
            : "media/news",
      }));
    },
    videogallery() {
      if (this.$store.state["our-purpose"].mjfFoundation != null) {
        return this.$store.state["our-purpose"].mjfFoundation.videos.map(
          (item) => ({
            youtube_url: item.link,
            video_cover: item.image_url,
            name: item.link_text[this.$language],
          })
        );
      } else {
        return [];
      }
    },
  },
  watch: {
    pageData() {
      this.$nuxt.$loading.finish();
    },
  },
};
